import React from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./pages/Dashboard";
import Journeys from "./components/Journeys";
import JourneyConfig from "./components/JourneyConfig";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import UpdateJourneyConfig from "./components/journeyConfig/UpdateJourneyConfig";
import AllTemplates from "./components/templates/AllTemplates";
import AllVerificationProfiles from "./components/verificationProfiles/AllVerificationProfiles";
import VerificationProfileForm from "./components/verificationProfiles/VerificationProfileForm";
import AllUser from "./components/user/AllUser";
import AllLogs from "./components/logs/AllLogs";
import AllVariables from "./components/variables/AllVariables";
import QuestionTemplateList from "./components/questionAnswer/QuestionTemplateList";
import QuestionList from "./components/questionAnswer/QuestionList";
import FunctionalityTemplateList from "./components/functionality/FunctionalityTemplateList";
import Monitoring from "./components/functionality/Moniotring";
import NotAuthorized from "./pages/NotAuthorized";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <Router>
      <div>
        <Toaster />
      </div>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />

        {/* Dashboard Routes */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute allowedRoles={["ADMIN", "USER", "GCUSER", "SUPPORT", "ASSESSOR"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route
            path="journeys"
            element={
              <ProtectedRoute allowedRoles={["ADMIN", "USER", "GCUSER", "ASSESSOR"]}>
                <Journeys />
              </ProtectedRoute>
            }
          />
          <Route
            path="templates/:id"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <UpdateJourneyConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="templates/create"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <UpdateJourneyConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="templates"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <JourneyConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="agent-template-associations"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <AllTemplates />
              </ProtectedRoute>
            }
          />
          <Route
            path="verification-settings"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <AllVerificationProfiles />
              </ProtectedRoute>
            }
          />
          <Route
            path="verification-settings/create"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <VerificationProfileForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="verification-settings/:profileId"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <VerificationProfileForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="users"
            element={
              <ProtectedRoute allowedRoles={["ADMIN", "SUPPORT"]}>
                <AllUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="logs"
            element={
              <ProtectedRoute allowedRoles={["ADMIN", "USER", "GCUSER", "ASSESSOR"]}>
                <AllLogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="variable-mappings"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <AllVariables />
              </ProtectedRoute>
            }
          />
          <Route
            path="question-answer"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <QuestionTemplateList />
              </ProtectedRoute>
            }
          />
          <Route
            path="question-answer/:templateId"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <QuestionList />
              </ProtectedRoute>
            }
          />
          <Route
            path="functionality"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <FunctionalityTemplateList />
              </ProtectedRoute>
            }
          />
          <Route
            path="monitoring"
            element={
              <ProtectedRoute allowedRoles={["ADMIN"]}>
                <Monitoring />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Catch-All Routes */}
        <Route path="/not-authorized" element={<NotAuthorized />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
